import React from 'react';
import { useHistory } from 'react-router';
import { useLocation, useParams } from 'react-router-dom';
import queryString from 'query-string';
// components
import Button, { IButtonTypes } from '@/components/ui/buttons/Button';
// images
import SSOLoginIcon from '@/public/images/sso-login-icon.svg';
// styles
import styles from './styles.module.scss';
// types
import { ITextStyles } from '@/components/ui/content/Text';
import {
  IEventCheckinType,
  ILoginType,
} from '@/components/landing-page-templates/ConfigLandingPage/types';
import { useDispatch } from 'react-redux';
import { ISSOLoginButtonProps } from './types';
import { redirectToSsoLoginPage } from '@/components/landing-page-templates/ConfigLandingPage/utils';
import { useMemoizedSelector } from '@/hooks/use-memoized-selector';
import { makeSelectEventById } from '@/models/event';

const SSOLoginButton = ({
  updateLoginMethod,
  existingLoginMethod,
  eventEntryType,
  isSpeakerPage,
}: ISSOLoginButtonProps) => {
  
  const history = useHistory();
  const location = useLocation();

  // Get the GET parameter for the redirect reference
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  // NOTE - this GET parameter is called 'ref'
  const { ref } = searchParams;
  const { eventId } = useParams<{ eventId: string }>();
  const event = useMemoizedSelector(makeSelectEventById, eventId);
  const { organizationId } = event;

  const dispatch = useDispatch();

  function handleOnClick() {
    // App level SSO Login
    if (!eventId) {
      // Get the 'ref' GET parameter and push it with the URL
      history.push(`/a/sso${ref ? `?ref=${ref}` : ''}`);
    }
    // PRODUCTION- DSG October 2021 event
    //  https://app.zuddl.com/p/a/event/acecf84e-3d6c-4575-a1df-8caa29398135
    else if (eventId === 'acecf84e-3d6c-4575-a1df-8caa29398135' || eventId === '3d9ad6f7-663b-453d-b045-ad004b9d7636') {
      dispatch({
        type: 'account/ssoLogin',
        payload: {
          ssoDomain: 'dcsg.com',
          redirectRef: location.pathname,
          eventId: eventId,
        },
      });
    } else if(eventEntryType !== IEventCheckinType.INVITE_ONLY && !isSpeakerPage) {
      redirectToSsoLoginPage(eventId, organizationId, dispatch);
    } else {
      // Update the current auth method as SSO; For invite only case, 
      // we collect the email to check if its invited before sso login
      updateLoginMethod(ILoginType.SSO);
    }
  }

  return (
    <div className={styles.ssoLoginContainer}>
      <Button
        onClick={handleOnClick}
        className={styles.socialButton}
        styleClass={
          existingLoginMethod
            ? IButtonTypes.NEW_SOCIAL_BUTTON_FULL
            : IButtonTypes.NEW_SOCIAL_BUTTON
        }
        type="button"
        textStyle={ITextStyles.DEFAULT}
      >
        <div data-testid="sign-in-with-SSO" className={styles.ssoLoginButton}>
          <img src={SSOLoginIcon} alt="SSO" />
          {existingLoginMethod ? (
            <p className={styles.ssoLoginButtonText}>Sign in with SSO</p>
          ) : (
              <p className={styles.ssoLoginButtonText}>SSO</p>
            )}
        </div>
      </Button>
    </div>
  );
};

export default SSOLoginButton;
